import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getEvent(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createEvent(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/event" + pathname, body);
}

export async function updateEvent(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/event" + pathname + queryParams, body);
}

export async function deleteEvent(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/event" + pathname + queryParams);
}
